
import { createSlice } from '@reduxjs/toolkit';

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState: {
    sidebarShow: true,
    sidebarUnfoldable: false,
  },
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarShow = !state.sidebarShow;
    },
    setSidebar: (state, action) => {
      state.sidebarShow = action.payload; 
    },
    setSidebarUnfoldable: (state, action) => {
      state.sidebarUnfoldable = action.payload; 
    },
  },
});

export const { toggleSidebar, setSidebar, setSidebarUnfoldable } = sidebarSlice.actions;
export default sidebarSlice.reducer;
